/**
 * Bridges `UserPreferencesContext` (language + density) to platform
 * `localePref` / `densityPref` via the preferences singleton.
 *
 * Application must not import app-kit; this adapter lives in the console.
 */

import {
  USER_PREF_DENSITY_KEY,
  USER_PREF_LANGUAGE_KEY,
  type UserPreferencesStorage,
} from '@vectorhub/application'
import { localePref, densityPref } from '@rammetec/app-kit/preferences'
import { preferencesService } from './preferences.bootstrap'

export const userPreferencesStorage: UserPreferencesStorage = {
  getItem(key) {
    if (key === USER_PREF_LANGUAGE_KEY) return preferencesService.get(localePref)
    if (key === USER_PREF_DENSITY_KEY) return preferencesService.get(densityPref)
    return null
  },
  setItem(key, value) {
    if (key === USER_PREF_LANGUAGE_KEY) {
      if (preferencesService.get(localePref) === value) return
      preferencesService.set(localePref, value)
      return
    }
    if (key === USER_PREF_DENSITY_KEY) {
      if (value !== 'comfortable' && value !== 'compact') return
      if (preferencesService.get(densityPref) === value) return
      preferencesService.set(densityPref, value)
    }
  },
  subscribe(key, cb) {
    if (key === USER_PREF_LANGUAGE_KEY) {
      return preferencesService.subscribe(localePref, cb)
    }
    if (key === USER_PREF_DENSITY_KEY) {
      return preferencesService.subscribe(densityPref, cb)
    }
    return () => {}
  },
}
